import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 6H2v16h16v-2H4V6zm18-4H6v16h16V2zM12 14.5v-9l6 4.5-6 4.5z"
}), 'VideoLibrarySharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VideoLibrarySharp.js
// module id = 7048
// module chunks = 2